import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const HalfA4_4 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser, settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const cashRef = useRef();
  const paylaterRef = useRef();
  const globalData = FormatedSaleData(data);
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  const formatCurrencyINR = (value) => {
    const formatted = Math.abs(value).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  const generateinvoiceHalfA4PDF = async () => {
   const doc = new jsPDF("p", "mm", "a4");
const pageW = doc.internal.pageSize.getWidth();
const pageH = doc.internal.pageSize.getHeight();
const HALF_PAGE_HEIGHT = 140;
const PADDING = 5;
const MARGIN_LEFT = PADDING;
const MARGIN_RIGHT = pageW - PADDING;
const centerX = pageW / 2;
let y = PADDING; // Starting height

if (globalData?.salefrom?.image) {
  try {
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    const logoBase64 = await urlToBase64(imagePath);
    const { width, height } = await loadImageDimensions(logoBase64);
    
    // 1. DRAW LOGO (Far Left)
    const maxWidth = 30;
    const maxHeight = 12;
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    const finalW = width * ratio;
    const finalH = height * ratio;

  const headerTopY = y;

// ==================== LOGO ====================
const logoX = MARGIN_LEFT;
const logoY = headerTopY;

doc.addImage(
  logoBase64,
  "PNG",
  logoX,
  logoY,
  finalW,
  finalH
);

// ==================== LEFT SIDE ====================
const leftStartX = logoX + finalW + 4;

doc.setFont("Inter-Bold", "bold");
doc.setFontSize(8);
doc.setTextColor(0);

doc.text(
  globalData?.salefrom?.title?.toUpperCase() || "",
  leftStartX,
  headerTopY + 4
);

let leftY = headerTopY + 8;

doc.setFont("Inter-Regular", "normal");
doc.setFontSize(7);
doc.setTextColor(0);

const addrLine1 = [
  globalData.salefrom?.addressline1,
  globalData?.salefrom?.addressline2,
    globalData?.salefrom?.district,
  globalData?.salefrom?.state,
  globalData?.salefrom?.pincode,
]
  .filter(Boolean)
  .join(", ");

// const addrLine2 = [
//   globalData.salefrom?.district,
//   globalData.salefrom?.state,
//   globalData.salefrom?.pincode,
// ]
//   .filter(Boolean)
//   .join(", ");

if (addrLine1) {
  doc.text(addrLine1, leftStartX, leftY);
  leftY += 3;
}

// if (addrLine2) {
//   doc.text(addrLine2, leftStartX, leftY);
//   leftY += 3;
// }

const phone = globalData?.salefrom?.phone;
const gstin = globalData.salefrom?.gstnumber;

if (phone) {
  doc.setFont("Inter-Bold", "bold");
  doc.text("Ph:", leftStartX, leftY);

  doc.setFont("Inter-Regular", "normal");
  doc.text(
    phone,
    leftStartX + doc.getTextWidth("Ph: ") + 1,
    leftY
  );

  leftY += 3;
}

if (gstin) {
  doc.setFont("Inter-Bold", "bold");
  doc.text("GSTIN:", leftStartX, leftY);

  doc.setFont("Inter-Regular", "normal");
  doc.text(
    gstin,
    leftStartX + doc.getTextWidth("GSTIN: ") + 1,
    leftY
  );

  leftY += 3;
}
// ==================== RIGHT SIDE ====================

const invLabel = "Invoice No. "; // Added a space for formatting
const invVal = globalData?.saleno || "-";

const invDateTime = DateConverter.ISOToDisplayFormat(
  DateConverter.convertToTimeZone(
    globalData?.saledate,
    isUser.timezone
  )
).time;

const dateStr = `DATE: ${
  globalData?.saledate
    ? DateConverter.ISOToDisplayFormat(globalData.saledate).date
    : "-"
}`;
// Added extra spacing before TIME to push it cleanly to the right as seen in image_5e40fa.png
const timeStr = `   TIME: ${invDateTime || "-"}`; 

let rightY = headerTopY + 3;

// 1. TAX INVOICE Heading
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(9);
doc.setTextColor(0); // Set to black to match image_5e40fa.png
doc.text(
  "TAX INVOICE",
  MARGIN_RIGHT,
  rightY,
  { align: "right" }
);

rightY += 4;

// 2. Invoice No. Block (Bold Value)
doc.setFont("Inter-Regular", "normal");
doc.setFontSize(7.5);
doc.setTextColor(0); // Muted color for label

const invValW = doc.getTextWidth(invVal);
doc.text(
  invLabel,
  MARGIN_RIGHT - invValW,
  rightY,
  { align: "right" }
);

doc.setFont("Inter-Bold", "bold");
doc.setTextColor(0); // Darker bold text for the actual number
doc.text(
  invVal,
  MARGIN_RIGHT,
  rightY,
  { align: "right" }
);

// 3. Draw the horizontal line directly below Invoice No.
rightY += 2; // Position for the line

// Calculate the total combined width of Date and Time strings
doc.setFont("Inter-Regular", "normal");
doc.setFontSize(7);
const totalDateTimeWidth = doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);
const lineStartX = MARGIN_RIGHT - totalDateTimeWidth;

doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || 200); 
doc.setLineWidth(0.1);
doc.line(lineStartX, rightY, MARGIN_RIGHT, rightY); // Horizontal divider

rightY += 3; // Position for the text below the line

// 4. Render Date and Time on a SINGLE line
const timeStrW = doc.getTextWidth(timeStr);
doc.setTextColor(0);

// Print Date (shifted left by the width of the Time string)
doc.text(
  dateStr,
  MARGIN_RIGHT - timeStrW,
  rightY,
  { align: "right" }
);

// Print Time (snapped directly to the right margin)
doc.text(
  timeStr,
  MARGIN_RIGHT,
  rightY,
  { align: "right" }
);

// ==================== HEADER BOTTOM ====================

const headerBottom = Math.max(
  leftY,
  rightY,
  headerTopY + finalH
);

y = headerBottom + 2;

  } catch (e) {
    console.warn("Header layout failed", e);
    y += 15;
  }
}


    y += 1;

    if (globalData?.saleto) {
      let rowHeight = 5; // Adjusted to fit address + padding
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
      );
      doc.setLineWidth(0.2);
      // doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);

      // 2. LEFT SIDE: "Customer Details :" and Customer Address
    // 1. Render the "To :" label in its default weight
doc.setFont("Inter-Regular", "normal"); // Or "Inter-Bold", depending on your preference for the label
doc.setFontSize(8);
doc.setTextColor(0);
doc.text("To : ", MARGIN_LEFT + 2, y + 3.5);

// 2. Calculate where the label ends to place the name next to it
const labelWidth = doc.getTextWidth("To : ");
const nameXPosition = MARGIN_LEFT + 2 + labelWidth;

// 3. Render the Name inline using Bold
doc.setFont("Inter-Bold", "bold");
doc.text(globalData?.saleto?.name || "", nameXPosition, y + 3.5);
doc.setFont("Inter-Regular", "normal");
// Adjust rowHeight dynamically if needed since we saved a line break
rowHeight += 3;
      const fullAddress = [
        globalData.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
      ]
        .filter(Boolean)
        .join(", ");
      const pinCode = globalData?.saleto?.pincode
        ? ` - ${globalData?.saleto?.pincode}`
        : "";
      if (fullAddress || pinCode) {
        const wrappedAddr = doc.splitTextToSize(
          fullAddress + pinCode,
          pageW / 2 + 10
        );
        doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 8);
        rowHeight += wrappedAddr.length * 3;
      }
     
    
      doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
      y += rowHeight;
    }
    /* -------------------------------------------------
     PRODUCT TABLE1
  ------------------------------------------------- */
    const rowCount = globalData?.saleitems?.length;
    // Set a default minimum height for the whole table body area (e.g., 60mm)
    // const totalBodyHeight = rowCount > 3 ? 0 : 60;
    // const dynamicMinHeight = rowCount > 0 ? totalBodyHeight / rowCount : 0;
    const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace =
      rowCount > 0 && rowCount <= 5
        ? targetTotalHeight - rowCount * standardHeight
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: "avoid",
      margin: {
        top: PADDING,
        left: PADDING,
        right: PADDING,
        bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 6.5,
        cellPadding: 1.5,
        valign: "top",
        lineWidth: 0, // No default borders
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight),
      },
      head: [[" SI", "Description of Good", "HSN/SAC",  "MRP","Disc", "RATE","QTY", "Tax Amt","GST %","CGST", "SGST","Total"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.title,
        it.hsnsac,
        `₹${it.mrp}`,
        `₹${it?.lineTotalDiscount}`,
        `₹${it.soldprice}`,
         `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,       
        `₹${it.lineTotalTaxAmount}`,
        `₹${it?.taxpercentage}%`,
        `₹${it?.lineTotalCgstAmount}`,
        `₹${it.lineTotalSgstAmount}`,
        `₹${it.lineTotalSoldPrice}`,
      ]),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },
        2: { cellWidth: 15, halign: "right" },
        3: { cellWidth: 16, halign: "right" },
        4: { cellWidth: 16, halign: "right" },
        5: { cellWidth: 16, halign: "right" },
        6: { cellWidth: 16, halign: "center" },
        7: { cellWidth: 16, halign: "right" },
        8: { cellWidth: 11, halign: "center" },
        9: { cellWidth: 16, halign: "right" },
        10: { cellWidth: 16, halign: "right" },
          11: { cellWidth: 16, halign: "right" },
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0 || colId === 6 || colId === 8) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 4 || colId === 5 || colId === 3 || colId === 7 || colId === 9 || colId === 10 || colId === 11)
            data.cell.styles.halign = "right";
        }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1,
            right: 0.1,
            top: 0,
            bottom: 0,
          };
          data.cell.styles.lineColor = selectedTheme?.templateTheme
            ?.borderColor || [200, 200, 200]; // Black vertical lines
          if (data.row.index === rowCount - 1) {
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
      didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      },
    });
const tableEndY = doc.lastAutoTable.finalY;

const borderColor =
  selectedTheme?.templateTheme?.borderColor || [200, 200, 200];

doc.setDrawColor(borderColor);
doc.setLineWidth(0.1);

// =====================================================
// SUMMARY ROW
// =====================================================

const summaryRowY = tableEndY;
const summaryRowH = 5;

doc.rect(
  PADDING,
  summaryRowY,
  pageW - PADDING * 2,
  summaryRowH
);

const colWidths = [
  10, // SI
  36, // Description
  15, // HSN
   16, // mrp
 16, // Disc
  16, // Rate
   16, // Qty  
  16, // Taxable
  11, // GST
  16, // CGST
  16, // SGST
  16, // Total
];

let x = PADDING;

colWidths.forEach((w) => {
  x += w;
  doc.line(x, summaryRowY, x, summaryRowY + summaryRowH);
});

const centerY = summaryRowY + 3.5;

doc.setFont("Inter-Bold", "bold");
doc.setFontSize(6);

doc.text("Total :", PADDING + 36, centerY);
doc.text(
  `₹${globalData?.totalmrp || 0}`,
  PADDING + 75,
  centerY,
  { align: "right" }
);

doc.text(
  `₹${globalData?.totaldiscount || 0}`,
  PADDING + 92,
  centerY,
  { align: "right" }
);

doc.text(
  `₹${globalData?.totalsaleprice || 0}`,
  PADDING + 108,
  centerY,
  { align: "right" }
);


doc.text(
  `₹${globalData?.totaltaxamount || 0}`,
  PADDING + 140,
  centerY,
  { align: "right" }
);

doc.text(
  `₹${globalData?.cgstamount || 0}`,
  PADDING + 167,
  centerY,
  { align: "right" }
);

doc.text(  
  `₹${globalData?.sgstamount || 0}`,
  PADDING + 183,
  centerY,
  { align: "right" }
);

doc.text(   
  `₹${globalData?.grandtotal || 0}`,
  pageW - PADDING - 2,
  centerY,
  { align: "right" }
);

// =====================================================
// RUPEES IN WORDS ROW
// =====================================================

const rowH = 5;
const wordsRowY = summaryRowY + summaryRowH;

const rightSectionWidth = 48;
const amountWidth = 0;

const totalLabelX = MARGIN_RIGHT - rightSectionWidth;
const totalValueX = MARGIN_RIGHT - amountWidth;

doc.rect(
  PADDING,
  wordsRowY,
  pageW - PADDING * 2,
  rowH
);

doc.line(
  totalLabelX,
  wordsRowY,
  totalLabelX,
  wordsRowY + rowH
);

doc.line(
  totalValueX,
  wordsRowY,
  totalValueX,
  wordsRowY + rowH
);

const textY = wordsRowY + rowH / 2 + 1;

doc.setFont("Inter-Bold", "bold");
doc.setFontSize(7);
doc.text("Rupees in words:", PADDING + 2, textY);

doc.setFont("Inter-Regular", "normal");

const words =
  isViewData?.amountinwords || "Zero Rupees Only";

doc.text(
  words,
  PADDING + 23,
  textY,
  {
    maxWidth:
      totalLabelX - PADDING - 17,
  }
);

doc.setFont("Inter-Bold", "bold");

doc.text(
`TOTAL  AMOUNT : ₹${globalData?.grandtotal}` ,
  MARGIN_RIGHT - 2,
  textY,
  {
    align: "right",
  }
);


// =====================================================
// TERMS SECTION START
// =====================================================

let currentSectionY = wordsRowY + rowH + 7;
   const TERMS_WIDTH = (pageW - PADDING * 2) * 0.85;

    // Handle Left Side: Format & wrap text boundaries 
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    const termLines = doc.splitTextToSize(terms || "", TERMS_WIDTH);
    const termsHeight = 4 + (termLines.length * 3);

    const sigSectionHeight = 18; 
    const totalSectionHeight = Math.max(sigSectionHeight, termsHeight);
 if (currentSectionY + totalSectionHeight > HALF_PAGE_HEIGHT - 5) {
    doc.addPage();
    currentSectionY = PADDING + 5; // Reset Y position to the top of the next page
  }

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("Terms & Conditions", PADDING, currentSectionY);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0);
    let termsTextY = currentSectionY + 4;
    termLines.forEach((line) => {
      doc.text(line, PADDING, termsTextY);
      termsTextY += 3;
    });    
    let signatureTopY = currentSectionY ; 

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        
        const ratio = Math.min(30 / width, 10 / height); 
        const imgW = width * ratio;
        const imgH = height * ratio;

        // Anchor signature image to snap right against the page margin edge
        const imgX = MARGIN_RIGHT - imgW;
        doc.addImage(base64, "PNG", imgX, signatureTopY, imgW, imgH);
        
        // Push the text label directly below the rendered image
        signatureTopY += imgH + 3; 
      } catch (e) {
        console.warn("Signature image rendering failed", e);
        signatureTopY += 8; // Fallback space if image fails to load
      }
    } else {
      signatureTopY += 8; // Placement for text if no image signature exists
    }

    // Print Right Side: Signature Base Text Line Label
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0);
    doc.text("Authorised Signature", MARGIN_RIGHT, signatureTopY, { align: "right" });


    // --- 4. BRANDING FOOTER SECTION ---
    // Update vertical page position reference point dynamically
     y = currentSectionY + totalSectionHeight + 4;
         
    if (storeSettings?.negobillBranding) {
  const minGapY = y + 3;
  const bottomLimitY = HALF_PAGE_HEIGHT - 5;
  let finalBrandingY = Math.max(minGapY, bottomLimitY);
  
  const normalText = "Powered by ";
  const boldText = "NegoBill.com";
  
  doc.setFontSize(8);   
  doc.setFont("Inter-Regular", "normal");
  const normalW = doc.getTextWidth(normalText);  
  doc.setFont("Inter-Bold", "bold");
  const boldW = doc.getTextWidth(boldText);  
  const totalWidth = normalW + boldW;
  const startX = MARGIN_RIGHT - totalWidth; 
  doc.setFont("Inter-Regular", "normal");
  doc.text(normalText, startX, finalBrandingY);
  doc.setFont("Inter-Bold", "bold");
  doc.text(boldText, startX + normalW, finalBrandingY);
}
    return doc;
  };

  const generateBillHalfA4PDF = async () => {};
  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBillHalfA4PDF();
    } else {
      doc = await generateinvoiceHalfA4PDF();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBillHalfA4PDF();
      } else {
        doc = await generateinvoiceHalfA4PDF();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const formatCurrency2 = (value) => {
    const amount = CurrencyConverter.toCurrency(value, "INR");
    const formatted = Math.abs(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 0, // Don't force .00
      maximumFractionDigits: 2, // Show up to 2 decimals if they exist (like .78)
    });

    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
  const grantotal = globalData?.grandtotal;
  const paidamount = globalData?.paidamount;
  const balanceDue = grantotal - paidamount;
  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);
  const isInterState =
    globalData?.salefrom?.statecode &&
    globalData?.saleto?.statecode &&
    globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
console.log("glob",globalData)
  return (
    <>
      <div className="invoice-scale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in" style={{ padding: "20px" }}>
                   <div className="tm_invoice_in">
                                   <table width="100%" className="pdfcontent">
                                     <tbody>
                                       <tr>
                                         <td width="50%" style={{ textAlign: "left" }}>
                                           <div className="d-flex gap-3 align-items-start">
                                             <div className="tm_logo">
                                               {("/assets/images/logo-light.png" ||
                                                 settings?.saleProfileData?.image) && (
                                                 <img
                                                   src={
                                                     settings?.saleProfileData?.image
                                                       ? uRLs.IMAGE_URL +
                                                         "profile/" +
                                                         settings?.saleProfileData?.image
                                                       : "/assets/images/logo-light.png"
                                                   }
                                                   className="img-rounded logo mb-0"
                                                   height="50"
                                                 />
                                               )}
                                             </div>
                                             <div
                                               style={{ fontSize: "13px", lineHeight: "16px" }}
                                             >
                                               <div style={{ fontWeight: "600" }} className="font-16">
                                                 {settings?.saleProfileData?.title || ""}{" "}
                                               
                                               </div>
                 <div className="font-14">
                        {settings?.saleProfileData?.addressline1}{" "} {settings?.saleProfileData?.addressline2}{" "}
                        {settings?.saleProfileData?.pincode || ""}
                      </div>
                     
                      <div className="font-13">
                        <span className="fw-bold">Ph:</span>{" "}
                        {settings?.saleProfileData?.phone}{" "}
                       
                      </div>       
                      <div>
                         <span className="fw-bold">GSTIN:</span>{" "}
                        {settings?.saleProfileData?.gstnumber}</div>                                      
                                                            
                                             </div>
                                           </div>
                                         </td>
                                         <td width="50%" style={{ textAlign: "right" }}>
                                           <div className="tm_primary_color tm_f50 tm_text_uppercase font-18 fw-bold">
                                             {globalData?.salemode &&
                                               formatTrackMode(globalData?.salemode)}
                                           </div>
                                           {globalData?.status === "CANCELLED" && (
                                             <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                               {globalData?.status}
                                             </span>
                                           )}
                                            <div style={{ flex: "1", textAlign: "right" }}>
                      <div className="mt-1"
                        style={{ display: "inline-block", textAlign: "right" }}
                      >
                        <div
                          className=" font-14"
                          style={{
                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            marginBottom: "5px",
                          }}
                        >
                          Invoice No.
                          <span className="fw-bold"> {globalData?.saleno}</span>
                        </div>
                        <div className="d-flex justify-content-end font-14">
                          {/* <span>DATE: {saleTime?.date}</span> */}
                          <span> DATE: {saleTime?.date}</span>
                          <span className="ms-3">TIME:{saleTime?.time}</span>
                        </div>
                      </div>
                    </div>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>                                 
                                   </div>
                

                  <div
                    className="d-flex mt-1"
                    style={{
                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        padding: "5px",
                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                      }}
                    >
                      <span className="fw-bold font-14">
                        To :                      <span className="font-14 ">{globalData?.saleto?.name}</span>
                      </span>

                      <div className="font-14">
                        {" "}
                        {globalData?.saleto?.addressline1 &&
                          `${globalData?.saleto?.addressline1}, `}
                        {globalData?.saleto?.addressline2 &&
                          `${globalData?.saleto?.addressline2}, `}
                        {globalData?.saleto?.district &&
                          `${globalData?.saleto?.district}, `}
                        {globalData?.saleto?.pincode &&
                          ` - ${globalData?.saleto?.pincode}`}
                      </div>
                    </div>
                    
                  </div>
                  <table
                    width="100%"
                    className="mt-0"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className=" fw-bold">
                        <th
                          className="force-style"
                          style={{
                            width: "40px",

                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                        >
                          {" "}
                          SI
                        </th>
                        <th
                          className="force-style"
                          style={{
                            textAlign: "left",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                        >
                          Description of Good
                        </th>
                          <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          HSN/SAC
                        </th>
                          <th
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          MRP
                        </th>
                                                <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Disc
                        </th>


                        <th
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          RATE
                        </th>
                         <th
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                        >
                          QTY
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Tax Amt
                        </th>
                           <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style"
                          style={{
                            width: "70px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          GST %
                        </th>
                          <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          CGST
                        </th>
                           <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          SGST
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((item, index) => (
                        <tr
                          key={index}
                          className="font-13"
                          style={{ height: "30px" }}
                        >
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                              textAlign: "center",
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              padding: "0 5px",
                            }}
                          >
                            {item?.title}
                          </td>
  <td 
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.hsnsac}
                          </td>
                             <td
                              className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.mrp}
                          </td>
                          <td  
                           className="pe-1"                        
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalDiscount}
                          </td>
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                            
                            }}
                          >
                            ₹{item?.soldprice}
                          </td>
                          <td                           
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.quantity} $
                            {(() => {
                              const unitCode = item?.isSecondaryUnit
                                ? item?.unitConfig?.secondaryUnitCode
                                : item?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>                          
                          
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalTaxAmount}
                          </td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            ₹{item?.taxpercentage}%
                          </td>
                            <td
                             className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalCgstAmount}
                          </td>
                            <td
                            className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalSgstAmount}
                          </td>
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.lineTotalSoldPrice}
                          </td>
                        </tr>
                      ))}

                      {[
                        ...Array(
                          Math.max(0, 5 - (globalData?.saleitems?.length || 0))
                        ),
                      ].map((_, i) => (
                        <tr key={`empty-${i}`} style={{ height: "50px" }}>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                        <tr 
      className="font-13 fw-bold" 
      style={{ 
        borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
      }}
    >
      <td style={{ textAlign: "right",  borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}></td>
      <td 
        colSpan="1" 
        style={{ 
          textAlign: "right", 
          padding: "6px",
          borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
          borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
        }}
      >
        Total :
      </td>
      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
     
      </td>
         <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
           {globalData?.totalmrp || ""}
      </td>
       <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
       {globalData?.totaldiscount || ""}
      </td>
     
     <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
        ₹{globalData?.totalsaleprice}
      </td>
      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
           
      </td>
     
     
       <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
        ₹{globalData?.totaltaxamount}
      </td>
      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
       
      </td>
      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
        ₹{globalData?.cgstamount}
      </td>
       <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
        ₹{globalData?.sgstamount}
      </td>
      
       <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
        ₹{globalData?.grandtotal}
      </td>
    </tr>
                      {/* Row 1: In Words & Total */}
                      <tr className="font-13">
                        <td
                          colSpan="9"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            padding: "6px",
                          }}
                        >
                          <span className="fw-bold">Rupees in words:</span>{" "}
                          {globalData?.amountinwords}
                        </td>
                        <td
                          colSpan="3"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "6px",
                            fontWeight: "bold",
                          }}
                        >
                          TOTAL AMOUNT : <span className="ms-2"> ₹{globalData?.grandtotal}</span> 
                        </td>
                    
                      </tr>
                     

                    </tfoot>
                  
                  </table>
                          <div className="d-flex mt-2 justify-content-between">
                          <div>
                          <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>
                                      <div className="terms-box">{terms}</div>
                           </div>
                            <div className="font-13 mt-2  ">
                              {storeSettings?.invoiceSettings?.signature ? (
                                <img
                                  src={
                                    uRLs.IMAGE_URL +
                                    storeSettings?.invoiceSettings?.signature
                                  }
                                  alt="Signature"
                                  width="120"
                                  style={{ marginBottom: "-5px" }}
                                />
                              ) : (
                                <div className="pt-4"></div>
                              )}
                              <div style={{ paddingTop: "5px" }}>
                                Authorised Signature
                              </div>
                            </div>

                          </div>
                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 font-13 d-flex justify-content-end ">
                        <span>
                          Powered By{" "}
                          <span className="fw-bold">NegoBill.com</span>
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1"></div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"}/>
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default HalfA4_4;
